import {cloneDeep, get} from 'lodash';
import {getArray, getBoolean, getObject, getString} from 'Core/helpers/data';
import {MessageSourceDataObject} from "DataObjects/message";
import * as viberCarouselEditorItemDataMap from 'Components/advanced/ViberCarousel/dataMap/item';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {MessageSourceDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	let bodySource;
	try { bodySource = JSON.parse(getString(result, 'bodySource')); }
	catch (e) { bodySource = undefined; }

	let customFieldsJson = null;
	try {
		if (!!get(result, 'customFieldsJson')) customFieldsJson = JSON.parse(result.customFieldsJson);
	} catch (e) {
		customFieldsJson = getString(e, 'message', '!');
	}

	result = new MessageSourceDataObject(
		getString(result, 'id'),
		getString(result, 'messageType'),
		getString(result, 'subject'),
		getString(result, 'body'),
		bodySource,
		get(result, 'image', null),
		getBoolean(result, 'containsVideo'),
		getString(result, 'videoUrl'),
		getString(result, 'videoThumbnail'),
		get(result, 'link', null),
		getString(result, 'linkText'),
		(!!result?.carouselItems ?
			getArray(result, 'carouselItems').map(viberCarouselEditorItemDataMap.input) :
			null
		),
		getObject(result, 'customFields'),
		getObject(result, 'replacements'),
		getString(result, 'templateId'),
		customFieldsJson,
	);

	return result;
}